import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { NotificationOutput } from '../model/notification.output';

export interface FetchNotificationByIdParams {
	readonly id: string;
}

@Injectable({ providedIn: 'root' })
export class FetchNotificationByIdApiQuery extends ApiQuery<
	NotificationOutput,
	FetchNotificationByIdParams
> {
	client = 'messaging';
	document = gql`
		query FetchNotificationById($id: UUID!) {
			fetchNotificationById(id: $id) {
				id
				type
				taskId
				documentId
				orgModuleId
				sourceUserId
				targetUserId
				contactsName
				updateTimestamp
				creationDateTime
				meeting {
					coachId
					endDate
					startDate
				}
			}
		}
	`;
	method = 'fetchNotificationById';
}
